import { ClassifyTag } from 'src/app/interfaces/shared/classifyTag';
import { Tag } from 'src/app/interfaces/shared/tag';
import { defaultImage, Image } from "./image";
import { defaultLabelProject, LabelProject } from "./labelProject";
export const ImageActionDetails = {
    viewed: { icon: "visibility", value: "Vue" },
    labeled: { icon: "label", value: "Labelisé" },
    corrected: { icon: "edit", value: "Corrigé" },
    controled: { icon: "check_circle", value: "Contrôlé" },
    deleted: { icon: "delete", value: "Supprimé" },
}

export interface StatusLabel {
    _id?: string;
    name: string;
    author?: string;
    createdDate?: string;
    boundingBox?: number[];
    probability?: number;
    optionalFields?: OptionalField[];
}

export interface UserActivity {
    action: "viewed" | "labeled" | "corrected" | "controled";
    user: string;
    date: Date;
    labels: StatusLabel[];
    optionalFields: OptionalField[];
    correction?: "zone" | "label" | "zone_label";
    imageStatus?: string;
}
export interface OptionalField {
    key: string;
    value: string[];
}

export interface LabelUpdate {
    labelProject: string;
    action: 'viewed'|'labeled'|'corrected'|'controled';
    labels: (Tag|ClassifyTag)[];
    optionalFields: any[];
}

export interface ImageStatus {
    id: string;
    image: Image;
    project?: string;
    labelProject: LabelProject | string;
    loadedBy?: string[];
    checkedBy?: string[];
    viewedBy?: string[];
    labeledBy?: string[];
    correctedBy?: string[];
    controledBy?: string[];
    optionalFields?: OptionalField[];
    history?: UserActivity[];
    labels?: StatusLabel[];
    aiLabels?: StatusLabel[];
    displayTags?: StatusLabel[];
    loaded?: boolean;
    checked?: boolean;
    viewed?: boolean;
    labeled?: boolean;
    corrected?: boolean;
    controled?: boolean;
    lastUpdate: Date;
    action?: string;
    createdDate?: string;
    note?: string;
    fromHse?: boolean;
}

export interface PostImageStatus {
    image: string;
    labelProject: string;
    labeledBy?: string[];
    viewedBy?: string[];
    correctedBy?: string[];
    controledBy?: string[];
    optionalFields?: [{
        key: string;
        value: string;
    }];
    labels?: [{
        name: string;
        boundingBox?: number[];
    }];
    viewed?: boolean;
    labeled?: boolean;
    corrected?: boolean;
    controled?: boolean;
    note?: string;
}

export interface PutImageStatus {
    id: string;
    image?: string;
    labelProject?: string;
    labeledBy?: string[];
    viewedBy?: string[];
    correctedBy?: string[];
    controledBy?: string[];
    optionalFields?: [{
        key: string;
        value: string;
    }];
    history?: [{
        action: "viewed" | "labeled" | "corrected" | "controled";
        user: string;
        date: Date;
        labels: Object[];
        optionalFields: OptionalField[];
        correction?: "zone" | "label" | "zone_label";
    }];
    labels?: [{
        name: string;
        boundingBox?: number[];
    }];
    viewed?: boolean;
    labeled?: boolean;
    corrected?: boolean;
    controled?: boolean;
    lastUpdate?: Date;
    note?: string;
}

export const defaultImageStatus: ImageStatus = {
    id: "",
    image: defaultImage,
    labelProject: defaultLabelProject,
    labeledBy: [],
    viewedBy: [],
    correctedBy: [],
    controledBy: [],
    optionalFields: [{
        key: "",
        value: [""]
    }],
    history: [{
        action: "viewed",
        user: "",
        date: new Date(),
        labels: [],
        optionalFields: [],
        correction: "zone"
    }],
    labels: [{
        name: "",
        boundingBox: []
    }],
    viewed: false,
    labeled: false,
    corrected: false,
    controled: false,
    note: "",
    lastUpdate: new Date()
};
